import { AFConstants, AppsFlyer } from 'appsflyer-capacitor-plugin'
import { Capacitor } from '@capacitor/core'
import UserStore from '@/store/user'
import WindowStore from '@/store/window'

export const appsFlyerInit = async () => {
  if (Capacitor.isNativePlatform()) {
    AppsFlyer.addListener(AFConstants.UDL_CALLBACK, (event) => {

      setTimeout(() => {
        console.log('DEEPLINK UDL')
        console.log(JSON.stringify(event))

        const userStore = UserStore()
        const userId = event.deepLink.deep_link_value || event.deepLink.deep_link_sub1

        if (userId) userStore.referralSet(userId, true)
      }, 1000)
    })

    AppsFlyer.initSDK({
      appID: '6463439764',
      devKey: Capacitor.getPlatform() === 'android' ? useRuntimeConfig().public.APPSFLYER_ANDROID : useRuntimeConfig().public.APPSFLYER_IOS,
      isDebug: true,
      waitForATTUserAuthorization: 10,
      minTimeBetweenSessions: 6,
      registerOnDeepLink: true,
      registerConversionListener: true,
      registerOnAppOpenAttribution: false,
      deepLinkTimeout: 4000,
      useReceiptValidationSandbox: true,
      useUninstallSandbox: true
    })

    AppsFlyer.setAppInviteOneLink({ onelinkID: 'FieW' })

    AppsFlyer.setOneLinkCustomDomain({
      domains: [ 'install.vibes.lgbt' ]
    })
  }
}

export const appsFlyerInviteLink = async (
  userId: string,
  options?: {
    campaign?: string
  }
) => {
  try {
    const inviteLink = await AppsFlyer.generateInviteLink({
      campaign: 'invite',
      referrerCustomerId: userId,
      channel: 'menu',
      brandDomain: 'install.vibes.lgbt',
      addParameters: {
        deep_link_value: userId
      }
    })

    return inviteLink.link
  } catch (e) {
    console.error('Error generating AppsFlyer invite link:', e)
    return null
  }
}